import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo lo recibo?',
    a: 'Inmediatamente después de tu compra recibís un email con el enlace de descarga. Accedés en menos de 10 minutos.'
  }, {
    q: '¿Es PDF? ¿Se puede imprimir?',
    a: 'Sí. Todo el material es PDF descargable. Podés leerlo en celular, tablet o computadora.'
  }, {
    q: '¿Cuánto tiempo por día necesito?',
    a: 'Entre 15 y 20 minutos. El sistema está diseñado para personas ocupadas que no tienen horas libres.'
  }, {
    q: '¿Qué pasa si me atraso?',
    a: 'Seguís desde donde estés. No reiniciás. El sistema te permite retomar sin culpa ni presión.'
  }, {
    q: '¿Sirve si mi familia no cree en esto?',
    a: "Sí. El Bono 3 ('Mi Familia No Cree') te da un guión exacto para avanzar sin conflicto, incluso si tu entorno no acompaña."
  }, {
    q: '¿Necesito comprar cosas adicionales?',
    a: 'No. Todo lo que necesitás está incluido en el material digital.'
  }, {
    q: '¿Necesito creer en algo específico?',
    a: 'No. El sistema funciona con hábitos, orden y estructura. No importa tu creencia: si lo aplicás, funciona.'
  }, {
    q: '¿Esto reemplaza terapia, médico o asesoría profesional?',
    a: 'No. Es una guía complementaria de hábitos y organización. Si necesitás ayuda profesional, buscala. Esto no la reemplaza.'
  }, {
    q: '¿Para quién NO es este producto?',
    a: 'Para quienes buscan soluciones mágicas, no quieren leer ni aplicar, o esperan resultados sin esfuerzo.'
  }, {
    q: '¿Hay soporte si tengo dudas?',
    a: 'Sí. Podés escribirnos a soporte@codigoderestauracion.com y te respondemos en 24-48 horas hábiles.'
  }, {
    q: '¿Qué medios de pago aceptan?',
    a: 'Tarjeta de crédito/débito, Mercado Pago, transferencia bancaria. Todos los medios disponibles en Argentina.'
  }, {
    q: '¿Puedo hacerlo si vivo con otras personas?',
    a: 'Sí. El sistema está pensado para que lo hagas vos, a tu ritmo, sin necesidad de que otros participen.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-32 px-4 bg-secondary-bg" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-16" data-id="element-44">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-45">
            Preguntas Frecuentes
          </h2>
          <div className="divider-gold mx-auto max-w-xs" data-id="element-46" />
        </motion.div>

        <div className="space-y-2.5 md:space-y-4" data-id="element-47">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="bg-card-bg border border-border-gold rounded-lg md:rounded-xl overflow-hidden shadow-sm" data-id="element-48">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none" data-id="element-49">
                  <span className="font-bold text-text-primary pr-3 text-sm md:text-base" data-id="element-50">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" />
                </button>
                <AnimatePresence data-id="element-52">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-53">
                      <div className="px-4 pb-4 md:p-5 md:pt-0 text-text-secondary text-sm md:text-base border-t border-border-gold" data-id="element-54">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}